import { render, staticRenderFns } from "./title1.vue?vue&type=template&id=56ec900c&scoped=true&"
import script from "./title1.vue?vue&type=script&lang=js&"
export * from "./title1.vue?vue&type=script&lang=js&"
import style0 from "./title1.vue?vue&type=style&index=0&id=56ec900c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ec900c",
  null
  
)

export default component.exports